import { Pipe, PipeTransform } from '@angular/core';
import {Constants} from '../contants';

@Pipe({
  name: 'orderStatus'
})
export class OrderStatusPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): unknown {

    if (value === 0) {
      return Constants.OrderStatuses.PENDING;
    } else if (value === 1) {
      return Constants.OrderStatuses.PROCESSING;
    } else if (value === 2) {
      return Constants.OrderStatuses.SHIPPED;
    } else if (value === 3) {
      return Constants.OrderStatuses.COMPLETED;
    } else {
      return Constants.OrderStatuses.REJECTED;
    }
  }

}
